import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AmaService } from '../ama.service';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.css']
})
export class DialogComponent implements OnInit {
  public SampleData;
  /*SampleData = {
    "status": 1,
    "data":
    {
      "sampleQuestions":
        [
          {
            "Q": "Have you taken covid-19 vaccination?",
            "C": [
              "No, haven't taken any dose yet",
              "Yes, have taken only dose 1",
              "Yes, have taken both doses"
            ],
            "R": [{}]
          },
          {
            "Q": "Have you taken a flight in last 3 months?",
            "C": [
              "Yes",
              "No"
            ],
            "R": [{}]
          },
          {
            "Q": "Which all OTT platforms'paid subscription do you currently have?",
            "C": [
              "Netflix",
              "Amazon Prime",
              "Disney Hotstar",
              "ZEE 5",
              "Voot",
              "Alt balaji",
              "None of the above"
            ],
            "R": [{ "Mx Player": "12.5%", "Netflix": "15.0%", "Voot": "10.0%", "Zee 5": "7.5%", "Amazone Prime": "32.5%", "Disney Hotstar": "22.5%" }]
          }
        ],
      "audience":
        [
          {
            "name": "Gender",
            "options": { "Male": 1, "Female": 0, "Both": 0 },
            "L": 0
          },
          {
            "name": "City",
            "options": { "Delhi NCR": 1, "Mumbai": 1, "Bengaluru": 0, "Chennai": 0, "Hyderabad": 0, "Pune": 0, "Ahmedabad": 0, "Lucknow": 0, "Add Centres": 2 },
            "L": 0
          },
          {
            "name": "Age",
            "options": { "Less than 18": 2, "18-24": 1, "24-30": 0, "30-40": 0, "More than 40": 2 },
            "L": 0
          },
          {
            "name": "NCCS",
            "options": { "NCCS A (70%)": 3, "NCCS B (30%)": 3 },
            "L": 1
          }
        ],
      "qProperties":
        [
          {
            "name": "Question Type",
            "options": { "Single Select": 1, "Multiple Select": 0, "Ranking": 2, "Rating": 2 },
            "L": 0
          }
        ],
      "qOptions": [],
      "TnCs": "GoldVIP Technology Solutions Private Limited (hereinafter 'the Company' or 'Crownit') is has created this AMA (Ask Me Anything) Offer whereby the user of this Offer can ask one free question to Crownit's large pool of panellists. Crownit, under its fair usage policy might restrict usage of the free question offer for each user to a specific usage frequency e.g. weekly one question. And may from time to time revisit this fair usage policy.Crownit will solicit a number of responses to each question asked by the user. The number of responses may vary from 100 to 1000. The user of this Offer understands that Crownit's AMA is getting responses from respondents across selected geography at random basis and this doesn't constitute as actual research for key business objectives for the user. For proper research, Crownit offers researcher support to discuss business objectives with users to arrive at systematic methodology and perform the research. This AMA is meant for a general understanding of the Indian consumer. Important business decisions should not be taken based on data of these results. Crownit may modulate the question to make it more understandable for its respondents. Crownit is not responsible to the users of the Offer for any outcome from the responses received from the AMA Offer. Crownit reserves the right to change any of the terms of this Offer at any time.For any questions, you may write to ask@crownit.in"
    }
  };*/
  constructor(
    public Dialog: MatDialogRef<DialogComponent>,public amaService:AmaService
  ) { };
  ngOnInit() { 
    this.SampleData=this.amaService.sampleDataFromApi;
    console.log(this.SampleData,this.amaService.sampleDataFromApi);
  }
  closeDialog = () => {
    this.Dialog.close();
  }

}
